export const googleReviews = async (err) => {
  if (err) {
    console.error(err);
  }

  if (
    document.getElementsByClassName('google-reviews').length > 0 ||
    document.getElementsByClassName('google-badge').length > 0
  ) {
    var googleReviews = document.getElementsByClassName('google-reviews')[0];
    var googleBadge = document.getElementsByClassName('google-badge')[0];

    const blogId = document.getElementsByTagName('html')[0].id;
    // Set the Place ID for Alpin Trend Group
    var placeId = 'ChIJ5Z-boYmVhEcRo5y0gq_2lio'; // Default Place ID Alpin Trend

    if (blogId === 'blog-4') {
      // Set the Place ID for Krone Churwalden
      placeId = 'ChIJHR9QrQq_hEcRD8wy44w_VpQ'; // Krone Churwalden Place ID
    }

    if (blogId === 'blog-5') {
      // Set the Place ID for the Pradaschier info page
      placeId = 'ChIJXXBMYHS_hEcRjim0PehPHf8'; // Pradaschier Place ID
      // Create a new Place instance with the specified Place ID
      // const place = new google.maps.places.Place({id: placeId});
    }
    if (blogId === 'blog-6') {
      // Set the Place ID for the Hotel Lenzerhorn
      placeId = 'ChIJlxDuPYOVhEcR0BqBmsa9-YY'; // Lenzerhorn Place ID
    }
    if (blogId === 'blog-7') {
      // Set the Place ID for the Posthotel Valbella
      placeId = 'ChIJAY18oES_hEcRA8FTjQiIJWM'; // Posthotel Valbella Place ID
    }

    if (blogId === 'blog-8') {
      // Set the Place ID for Swiss Heidi Hotel
      // eslint-disable-next-line no-unused-vars
      placeId = 'ChIJHU2O0aLLhEcRFckISEXwMXw'; // Swiss Heidi Hotel Place ID
    }

    // Create a map instance (required for PlacesService, but can be hidden)

    // init array for places
    // eslint-disable-next-line no-undef
    //

    // Set rating stars count variables
    var ratingFullStars = 0,
      hasHalfStar = false;

    if (googleBadge) {
      // implement caching to avoid CORS issues and quota limits
      let cachedPlace,
        place = {};

      // load data from app/places-cache-<blogId>.json with the current blog id if it exists and is less than 24 hours old
      await fetch(
        `/wp-content/themes/alpintrend/app/places-cache-${blogId}.json`,
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then((data) => {
          // Use cached data
          // console.log('Using cached Google Places data:', data);

          // Create a new object to hold all cached reviews
          cachedPlace = {
            result: data.result,
          };
        })
        .catch((error) => {
          // If there's an error (e.g., file doesn't exist), fetch new data
          console.log('Error reading cache file', error);
        });

      // Use the cached place data if available
      if (cachedPlace && cachedPlace.result) {
        place.rating = cachedPlace.result.rating;
        place.userRatingCount = cachedPlace.result.user_ratings_total;
        place.displayName = cachedPlace.result.name;
      }

      var googleBadgeWrapper = googleBadge.querySelector('.wp-block-column');
      // Display the Google badge with the place information

      googleBadgeWrapper.innerHTML = `<div class="google-badge-content">
        <img src="/wp-content/themes/alpintrend/resources/images/google-reviews-color.png" class="google-badge-icon" alt="Google Badge Icon" />


            <div class="google-badge-rating">
            <div class="google-badge-rating-value">${place.rating}</div>
              <div class="google-badge-rating-stars">`;

      // Generate ratings stars markup based on the rating
      if (place.rating % 1 !== 0) {
        //round the rating to the lower whole number
        ratingFullStars = Math.floor(place.rating);
        hasHalfStar = true;
      } else {
        ratingFullStars = place.rating;
      }
      // full stars
      for (let i = 0; i < ratingFullStars; i++) {
        googleBadgeWrapper.querySelector(
          '.google-badge-rating-stars',
        ).innerHTML +=
          `<span class="star"><img src="https://maps.gstatic.com/consumer/images/icons/2x/ic_star_rate_14.png" /></span>`;
      }

      // half starts
      // check if value is not rounded
      if (hasHalfStar) {
        // If the rating is not a whole number, add a half star
        googleBadgeWrapper.querySelector(
          '.google-badge-rating-stars',
        ).innerHTML +=
          `<span class="star half"><img src="https://maps.gstatic.com/consumer/images/icons/2x/ic_star_rate_half_14.png" /></span>`;
      }

      // empty stars
      if (hasHalfStar) {
        ratingFullStars + 1;
      }
      let emptyStars = 5 - (ratingFullStars + 1);
      if (emptyStars > 0) {
        for (let i = 0; i < emptyStars; i++) {
          googleBadgeWrapper.querySelector(
            '.google-badge-rating-stars',
          ).innerHTML +=
            `<span class="star empty"><img src="https://maps.gstatic.com/consumer/images/icons/2x/ic_star_rate_empty_14.png" /></span>`;
        }
      }
      googleBadgeWrapper.innerHTML += `</div>`;

      googleBadgeWrapper.querySelector('.google-badge-content').innerHTML += `
              <div class="google-reviews-count-total">${place.userRatingCount} reviews</div>
            </div>
          </div>`;
    }

    if (googleReviews) {
      // implement caching to avoid CORS issues and quota limits
      let cachedPlace;

      // load data from app/places-cache-<blogId>.json with the current blog id if it exists and is less than 24 hours old
      await fetch(
        `/wp-content/themes/alpintrend/app/places-cache-${blogId}.json`,
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then((data) => {
          // Use cached data
          // console.log('Using cached Google Places data:', data);

          // Create a new object to hold all cached reviews
          cachedPlace = {
            reviews: data.result.reviews,
          };
        })
        .catch((error) => {
          // If there's an error (e.g., file doesn't exist), fetch new data
          console.log('Error reading cache file', error);
        });

      // Call fetchFields, passing the desired data fields.

      var itemsArray = [];

      if (cachedPlace.reviews && cachedPlace.reviews.length > 0) {
        // Sort reviews by publish time, newest first

        cachedPlace.reviews.sort((a, b) => {
          return new Date(b.time) - new Date(a.time);
        });

        //for (var i = 0; i < place.reviews.length; i++) {
        for (var i = 0; i < 3; i++) {
          let reviewRating = cachedPlace.reviews[i].rating,
            reviewText = cachedPlace.reviews[i].text,
            authorName = cachedPlace.reviews[i].author_name,
            authorUri = cachedPlace.reviews[i].author_uri,
            authorPhoto = cachedPlace.reviews[i].profile_photo_url,
            publishTime = cachedPlace.reviews[i].time,
            publishDate = new Date(publishTime * 1000);

          // convert cachedPlace.reviews[i].time to a readable date
          publishDate = publishDate.toLocaleDateString('de-DE', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
          });

          // Generate ratings stars markup based on the rating
          var reviewRatingStarsMarkup = '';
          if (reviewRating % 1 !== 0) {
            //round the rating to the lower whole number
            ratingFullStars = Math.floor(reviewRating);
            hasHalfStar = true;
          } else {
            ratingFullStars = reviewRating;
            hasHalfStar = false;
          }
          // full stars
          for (let j = 0; j < ratingFullStars; j++) {
            reviewRatingStarsMarkup += `<span class="star"><img src="https://maps.gstatic.com/consumer/images/icons/2x/ic_star_rate_14.png" /></span>`;
          }

          // half starts
          // check if value is not rounded
          if (hasHalfStar) {
            // If the rating is not a whole number, add a half star
            reviewRatingStarsMarkup += `<span class="star half"><img src="https://maps.gstatic.com/consumer/images/icons/2x/ic_star_rate_half_14.png" /></span>`;
          }

          // empty stars
          if (hasHalfStar) {
            ratingFullStars + 1;
          }
          let emptyStars = 5 - (ratingFullStars + 1);
          if (emptyStars > 0) {
            for (let i = 0; i < emptyStars; i++) {
              reviewRatingStarsMarkup += `<span class="star empty"><img src="https://maps.gstatic.com/consumer/images/icons/2x/ic_star_rate_empty_14.png" /></span>`;
            }
          }

          // If the review text is too long, truncate it to 200 characters
          var reviewTextFull = '';
          if (reviewText.length > 200) {
            reviewTextFull = `<p class='review-text-full'> ${reviewText} </p>`;
            reviewText = reviewText.substring(0, 200) + '...';
            // show more link

            reviewText += `<span id="more-link" class="more-link">Weiterlesen</span>`;
          }

          itemsArray[i] = `<div class="review">
          <div class="reviewer-info">
                <img src="${authorPhoto}" alt="${authorName}" class="reviewer-photo" />    
                <div class="reviewer-name-and-date">
                    <a href="${authorUri}" class="reviewer-name" target="_blank">${authorName}</a>
                    <div class="review-date">${publishDate}</div>
                </div>
            </div>
            <div class="rating"> ${reviewRatingStarsMarkup}</div>
            <div class="review-text">${reviewTextFull}<p class="review-text-paragraph">${reviewText}</p></div></div>`;
        }

        // More link function to show full text of review
        document.addEventListener('click', function (e) {
          if (e.target && e.target.id === 'more-link') {
            // Get the parent review element
            const reviewElement = e.target.closest('.review');
            // Find the review text paragraph
            const reviewText = reviewElement.querySelector('.review-text p');
            // Remove the "Weiterlesen" link
            e.target.remove();

            // Show the full text of the review
            reviewText.style.display = 'none';
            const reviewTextFull =
              reviewElement.querySelector('.review-text-full');
            const reviewTextTruncated = reviewElement.querySelector(
              '.review-text-paragraph',
            );
            if (reviewTextFull) {
              reviewTextFull.style.display = 'block';
              reviewTextTruncated.style.display = 'none';
            }
          }
        });
      } else {
        itemsArray[0] = 'No reviews were found for ' + cachedPlace.name + '.';
      }

      // loop through items array and wrap three items in a div with class "swiper-slide"
      itemsArray = itemsArray.map((item, index) => {
        if (index % 3 === 0) {
          return `<div class="swiper-slide">${item}`;
        } else if (index % 3 === 2 || index === itemsArray.length - 1) {
          return `${item}</div>`;
        }
        return item;
      });

      // Join the items array into a single string
      let itemsString = itemsArray.join('');

      document.getElementsByClassName('google-reviews-wrapper')[0].innerHTML =
        itemsString;

      // Initialize Swiper async
      /*       if ( 'undefined' === typeof Swiper ) {
        const asyncSwiper = elementorFrontend.utils.swiper;

        new asyncSwiper( swiperElement, swiperConfig ).then( ( newSwiperInstance ) => {
            console.log( 'New Swiper instance is ready: ', newSwiperInstance );

            mySwiper = newSwiperInstance;
        } );
    } else {
        console.log( 'Swiper global variable is ready, create a new instance: ', Swiper );

        mySwiper = new Swiper( swiperElement, swiperConfig );
    } */
    }
  }
};
import.meta.webpackHot?.accept(googleReviews);
